/*
 * @desc:
 * @version:
 * @Author: chentian05@meituan.com
 * @Date: 2024-01-31 10:36:14
 * @LastEditors: chentian05@meituan.com
 * @LastEditTime: 2024-01-31 10:36:14
 */
import * as React from 'react'
import ResourcePosition from '@sailor/mkt-resource-position-sdk'
import { getUserLocation } from '@Common/utils'
import { reportRaptorMetrics } from '@Common/SLRaptor'
import { bannerDowngradeSwitch, getResourcePositionList } from '../../../service/api'
import './index.css'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IProps {}

const COUPON_CHANNEL_ID = '10097'

/**
 * 我的优惠券列表-新版资源位banner
 */
class MyCouponResourceBanner extends React.Component<IProps, any> {
  comRef: any

  constructor (props: IProps) {
    super(props)
    this.state = {
      deliveryData: undefined,
      resourceDemote: false,
    }
  }

  bannerResourceDowngradeSwitch = async () => {
    try {
      // 获取资源位接口参数
      const resourceParams: any = {
        channelId: COUPON_CHANNEL_ID,
        version: Mach.env.bundleVersion,
      }
      let res = await bannerDowngradeSwitch(resourceParams)
      // 判断是否降级用新的资源位组件还是老的
      const isShowDemote = [0, 1].includes(res?.data)
      this.setState({ resourceDemote: isShowDemote })
    } catch (e) {
      // 如果降级开关获取失败，默认开启新的资源位
      this.setState({ resourceDemote: true })
    }
  }

  componentDidMount () {
    this.bannerResourceDowngradeSwitch()
    // 初始化资源位的数据
    const loc = getUserLocation()
    const positionRequest = {
      // channelId: COUPON_CHANNEL_ID,
      commonChannelId: 'coupon-banner-10005',
      longitude: loc?.actualLongitude,
      latitude: loc?.actualLatitude,
      homePageLongitude: loc?.longitude,
      homePageLatitude: loc?.latitude,
      fingerPrint: true,
    }
    getResourcePositionList(positionRequest)
      .then(activityInfo => {
        if (activityInfo.code === 0) {
          this.setState({ deliveryData: activityInfo?.data })
          if (activityInfo?.data?.launchTaskList?.length > 0 && this.state.resourceDemote) {
            // 上报券列表banner曝光量（新版）
            reportRaptorMetrics({ coupon_list_banner_mv: 1 })
          }
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  render () {
    const { deliveryData, resourceDemote } = this.state
    if (!deliveryData || !resourceDemote) return null
    const screenWidth = Mach.env.screenWidth // 屏幕宽度
    const swiperWidth = Math.ceil(screenWidth * (351.0 / 375.0)) // 单个卡片宽度： 根据屏幕宽度计算
    const swiperHeight = Math.ceil(swiperWidth * (128.0 / 351.0)) // 卡片高度：保持宽高比固定
    return (
      <view className="section-header-con" style={{ height: swiperHeight }}>
        <ResourcePosition
          ref={ref => {
            this.comRef = ref
          }}
          type="PULL"
          id={COUPON_CHANNEL_ID} // 资源位channelId
          lxConfig={{
            cid: 'c_waimai_c_overseas_tcfio133', // 页面埋点cid
            lxParams: {
              // 所有需要的埋点参数
            },
          }}
          inputParams={{
            imageHeight: 128, // 图片按照375宽度折算的高度
            imageWidth: 351, // 图片按照375宽度折算的宽度
            innerIndicator: true,
            isGoldInnerIndicator: true, // 计数器内置还是外置
          }} // 资源位需要其他的参数
          data={deliveryData} // 投放平台数据
        />
      </view>
    )
  }
}

export default MyCouponResourceBanner
